import { v4 as uuid } from 'uuid';

const STORAGE_KEY = 'USER_ID';
export const USER_ID = localStorage.getItem(STORAGE_KEY) || uuid();

localStorage.setItem(STORAGE_KEY, USER_ID);

export enum AudioCallStatuses {
  calling,
  connecting,
  connected
}
